import httpClient from '@/common/http'

export default {
  getCountries() {
    return httpClient.request('get', 'common/countries')
  },
  getCurrencies() {
    return httpClient.request('get', 'common/currencies')
  }
}